import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const ViewCardSizesRecord = Record({
  // Calculate and store card sizes for each view type
  timelineCardSize: null,
  narrativeCardSize: null,
  relationshipCardSize: null,
  mindmapCardSize: null
});

const data = {
  objects: {
    timelineCardSize: "FlatRectRecord",
    narrativeCardSize: "FlatRectRecord",
    relationshipCardSize: "FlatRectRecord",
    mindmapCardSize: "FlatRectRecord"
  }
};

createFromJS.registerCallback("ViewCardSizesRecord", createFromJS.createNestedCallback(ViewCardSizesRecord, data));
